import { render, staticRenderFns } from "./ReviewTasks.vue?vue&type=template&id=4078ba3e&scoped=true"
import script from "./ReviewTasks.vue?vue&type=script&lang=js"
export * from "./ReviewTasks.vue?vue&type=script&lang=js"
import style0 from "./ReviewTasks.vue?vue&type=style&index=0&id=4078ba3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4078ba3e",
  null
  
)

export default component.exports